/**
 * Activar HumanInk Writing Coach CON EL CORREO: lo que se le dice al autor. Sin claves.
 *
 * Desde el 11-oct-2026 la aplicación se compra en una página de pago (99 €, de por vida) o se consigue con el código de
 * la comunidad, y queda a nombre del CORREO que se escribe allí. Aquí el autor pone ese correo, le llega un código de
 * seis cifras y lo escribe. Las claves de HumanInk para Word (el producto anterior) NO abren este: es otro producto.
 *
 * Al pedir el código la respuesta es SIEMPRE la misma, tenga algo ese correo o no: si dijera «ese correo no consta»,
 * el panel serviría para averiguar quién ha comprado.
 */
export const FRASE_DE_ACTIVAR =
  "Con el correo que pusiste al comprarla (o al usar el código de la comunidad). No hay ninguna clave que copiar.";
export const FRASE_DE_CODIGO_ENVIADO =
  "Si ese correo tiene la aplicación a su nombre, te acaba de llegar un código de seis cifras. Mira también en la carpeta de spam.";
/** A quien trae guardada una clave del producto anterior: por qué no se abre y qué hacer. */
export const FRASE_CLAVE_DE_ANTES =
  "Writing Coach es un producto nuevo: la clave de HumanInk para Word de antes no lo abre (tu versión anterior sigue funcionando con ella). Cómpralo —o usa el código de la comunidad al comprar— y actívalo aquí con tu correo.";
export const FRASE_SIN_PEDIR = "No se ha podido pedir el código. Prueba otra vez en un momento.";

export const esCorreo = (s: string): boolean => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(s ?? "").trim());
export const esCodigo = (s: string): boolean => /^\d{6}$/.test(String(s ?? "").trim());

export type RespuestaDeCanjear = { ok?: boolean; error?: string; quedan?: number; desconectados?: number; maximo?: number } | null;

/**
 * Lo que dice Ajustes cuando la aplicación está activada: CÓMO lo está. El 11-oct-2026 Rais vio «✓ Activada» en un
 * ordenador que se había activado solo con su compra, y no supo por qué no le dejaba poner el correo.
 */
export function fraseDeActivada(lic: { via?: string | null; plan?: string | null; tier?: string | null } | null): string {
  if (lic?.via === "derecho" && lic.plan === "vitalicia") return "✓ Activada de por vida, con tu compra";
  if (lic?.via === "derecho" || lic?.via === "suscripcion") return "✓ Activada";
  return "✓ Activada con tu clave";
}

/** Lo que se dice al canjear el código: si ha ido bien, y la frase. */
export function fraseDeCanjear(r: RespuestaDeCanjear): { bien: boolean; frase: string } {
  if (r && r.ok === true) {
    return { bien: true, frase: (r.desconectados ?? 0) > 0
      ? `Activada. Vale para ${r.maximo ?? 3} ordenadores: se ha desconectado el que llevaba más tiempo sin usarse.`
      : "Activada." };
  }
  const quedan = r?.quedan;
  const de: Record<string, string> = {
    // El servidor contesta lo mismo a un código equivocado, caducado o ya usado (no dice cuál, a propósito).
    codigo_incorrecto: quedan == null ? "Ese código no es, o ha caducado. Míralo otra vez o pide otro."
      : quedan > 0 ? `Ese código no es. Te ${quedan === 1 ? "queda 1 intento" : `quedan ${quedan} intentos`}.`
        : "Ese código no es, y ya no quedan intentos. Pide otro.",
    codigo_caducado: "Ese código ha caducado o ya se usó. Pide otro.",
    demasiados_intentos: "Demasiados intentos con ese código. Pide otro.",
    sin_derecho: "Ese correo no tiene la aplicación a su nombre. Usa el correo que pusiste al comprarla.",
    faltan_datos: "Faltan el correo o el código.",
  };
  return { bien: false, frase: de[String(r?.error ?? "")] ?? "No se ha podido activar. Prueba otra vez en un momento." };
}
